import Image from "next/image";
import { FC, useState } from "react";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import styles from "../../../styles/italianStory/ItalianStory.module.scss";
import { StoriesEntity } from "../../../models/italianStory";

const ItalianStory: FC<{
    article: StoriesEntity;
    className?: string;
}> = ({ article, className = "my-4" }) => {
    const {
        h1,
        h2,
        h3,
        colorH1,
        colorH2,
        colorH3,
        link,
        body,
        bodyDelta,
        image,
        citation,
    } = article;
    const [errorImage, setErrorImage] = useState(false);

    const converter = new QuillDeltaToHtmlConverter(bodyDelta?.ops ?? []);

    const html = converter.convert();
    return (
        <div className={`${styles.italianStory} ${className}`}>
            {!!h1 && <h1 style={{ color: colorH1 || "#23262f" }}>{h1}</h1>}
            {!!h2 && <h2 style={{ color: colorH2 || "#23262f" }}>{h2}</h2>}
            {!!h3 && <h3 style={{ color: colorH3 || "#23262f" }}>{h3}</h3>}
            {!!link && (
                <a href={link} target="_blank" rel="noreferrer">
                    {link}
                </a>
            )}
            {!!bodyDelta && bodyDelta?.ops ? (
                <div
                    dangerouslySetInnerHTML={{
                        __html: html,
                    }}
                />
            ) : (
                <p> {body} </p>
            )}
            {!!image && (
                <div className={styles.italianStoryImage}>
                    <div className={styles.italianStoryImageContainer}>
                        <Image
                            src={
                                errorImage
                                    ? "/images/tours/across-italy-reduced.jpg"
                                    : image
                            }
                            alt=""
                            fill
                            onError={() => setErrorImage(true)}
                        />
                    </div>
                </div>
            )}
            {!!citation && <blockquote>{citation}</blockquote>}
        </div>
    );
};

export default ItalianStory;
